import { createAsyncThunk } from '@reduxjs/toolkit';

import { SecondaryMarketService } from 'api';

import { asyncPayloadCreator } from 'utils';

export const acceptCounteroffer = createAsyncThunk(
	'secondaryMarket/acceptCounteroffer',
	(id: string, { rejectWithValue }) =>
		asyncPayloadCreator(id, { rejectWithValue }, SecondaryMarketService.acceptCounteroffer),
);
